import angular from 'angular';
import 'localforage';
import 'angular-localforage';
import constantsModuleName from '../constants';
import logServiceModule from './LogService';

class ApplicationCache {
  constructor($localForage, DEBUG, LogService) {
    this.$localForage = $localForage;
    this.DEBUG = DEBUG;
    this.LogService = LogService;
  }

  getItem(name) {
    let promise = this.$localForage.getItem(name);
    if (this.DEBUG) {
      promise = promise.then(result => {
        return result;
      });
    }
    return promise;
  }

  setItem(name, value) {
    let promise = this.$localForage.setItem(name, value);
    if (this.DEBUG) {
      promise = promise.then(result => {
        return result;
      });
    }
    return promise;
  }

  removeItem(name) {
    let promise = this.$localForage.removeItem(name);
    if (this.DEBUG) {
      promise = promise.then(result => {
        return result;
      });
    }
    return promise;
  }

  clear() {
    let promise = this.$localForage.clear();
    if (this.DEBUG) {
      promise = promise.then(result => {
        return result;
      });
    }
    return promise;
  }
}

const moduleName = 'recaps.services.ApplicationCache';
let module = angular.module(moduleName, [
  'LocalForageModule',
  constantsModuleName,
  logServiceModule.name,
]);

module.service('ApplicationCache', ApplicationCache)
  .config($localForageProvider => {
    $localForageProvider.config({
      name: 'staff_application_cache',
    })
  });

export default module;
